/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FoundKnowledgeGraphValue from './FoundKnowledgeGraphValue';

/**
 * The FindKnowledgeGraphRelationshipValuesResponseHeadCeas model module.
 * @module model/FindKnowledgeGraphRelationshipValuesResponseHeadCeas
 * @version 2.8.0
 */
class FindKnowledgeGraphRelationshipValuesResponseHeadCeas {
    /**
     * Constructs a new <code>FindKnowledgeGraphRelationshipValuesResponseHeadCeas</code>.
     * @alias module:model/FindKnowledgeGraphRelationshipValuesResponseHeadCeas
     * @param foundKnowledgeGraphValues {Array.<module:model/FoundKnowledgeGraphValue>} 
     */
    constructor(foundKnowledgeGraphValues) { 
        
        FindKnowledgeGraphRelationshipValuesResponseHeadCeas.initialize(this, foundKnowledgeGraphValues);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, foundKnowledgeGraphValues) { 
        obj['foundKnowledgeGraphValues'] = foundKnowledgeGraphValues;
    }

    /**
     * Constructs a <code>FindKnowledgeGraphRelationshipValuesResponseHeadCeas</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FindKnowledgeGraphRelationshipValuesResponseHeadCeas} obj Optional instance to populate.
     * @return {module:model/FindKnowledgeGraphRelationshipValuesResponseHeadCeas} The populated <code>FindKnowledgeGraphRelationshipValuesResponseHeadCeas</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FindKnowledgeGraphRelationshipValuesResponseHeadCeas();

            if (data.hasOwnProperty('foundKnowledgeGraphValues')) {
                obj['foundKnowledgeGraphValues'] = ApiClient.convertToType(data['foundKnowledgeGraphValues'], [FoundKnowledgeGraphValue]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/FoundKnowledgeGraphValue>} foundKnowledgeGraphValues
 */
FindKnowledgeGraphRelationshipValuesResponseHeadCeas.prototype['foundKnowledgeGraphValues'] = undefined;






export default FindKnowledgeGraphRelationshipValuesResponseHeadCeas;

